"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiGooglePlus = function IconUiGooglePlus(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M9.721 38.224c5.94 2.286 13.553.728 17.345-4.607 2.5-3.37 3.043-7.708 2.752-11.784-4.862-.037-9.717-.029-14.572-.015-.008 1.732 0 3.465.007 5.2 2.9.095 5.816.051 8.72.095-1.281 6.441-10.045 8.53-14.681 4.323-4.768-3.69-4.542-11.784.415-15.212 3.464-2.766 8.392-2.082 11.857.313a54.342 54.342 0 0 0 3.865-4 15.454 15.454 0 0 0-10.183-3.77C7.392 8.505.172 15.384.041 23.237a15.254 15.254 0 0 0 9.68 14.987zm29.559-7.679h4.338q.011-2.172.029-4.352c1.456-.015 2.905-.022 4.353-.037v-4.331c-1.448-.014-2.9-.014-4.353-.029a898.54 898.54 0 0 1-.029-4.352h-4.331c-.014 1.448-.029 2.9-.036 4.352-1.456.008-2.9.015-4.353.029v4.331l4.353.044c.015 1.448.015 2.9.029 4.345z"
  }));
};

IconUiGooglePlus.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiGooglePlus;
exports.default = _default;